import cn from 'classnames';
import React, { useRef } from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const InputBox = ({
  label,
  value,
  setValue,
  widthClass,
  name,
}: {
  label: string;
  value: string;
  setValue: Setter<string>;
  widthClass?: string;
  name?: string;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={cn(
        'relative flex flex-col text-base cursor-pointer group-focus:cursor-auto w-full overflow-hidden rounded-t group pt-2 text-left font-sans bg-white group-hover:bg-blue-100 hover:bg-blue-100 border-1 border-gray-200',
        widthClass ?? 'w-40',
      )}
      onClick={() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      <p className={cn('text-xs px-2 text-gray-900')}>{label}</p>

      <input
        ref={inputRef}
        type={'text'}
        name={name}
        value={value}
        className="form-input peer block w-full border-none py-0 px-2 mb-1.5 outline-none focus:outline-none bg-transparent text-sm ring-0 focus:ring-0 leading-5"
        onChange={(value) => setValue(value.currentTarget.value)}
      />

      <div className="border-b-2 border-transparent peer-focus:border-secondary" />
    </div>
  );
};
